<template>
	<div>
		<h1>Planification</h1>

		<b-table striped hover :items="jobs" :fields="fields">
			<template v-slot:cell(project)="data">
				<router-link
					:to="{
						name: 'planification_job',
						params: { id: data.item._id },
					}"
					>{{ data.value }}</router-link
				>
			</template>
			<template v-slot:cell(nextRunAt)="data">
				{{
					!data.item.repeatInterval && data.item.lockedAt === null
						? "terminé"
						: data.value
				}}
			</template>
		</b-table>

		<b-button @click="new_job">Nouvelle planification</b-button>
	</div>
</template>

<script>
	import store from "../store";
	import agenda from "../services/agenda.js";
	import projects from "../services/projects.js";

	export default {
		name: "agenda",
		data() {
			return {
				list_projects: {},
				jobs: [],
				fields: [
					{
						key: "project",
						label: "Projet",
					},
					{
						key: "lastRunAt",
						label: "Précédent déclenchement",
					},
					{
						key: "nextRunAt",
						label: "Prochain déclenchement",
					},
					{
						key: "repeatInterval",
						label: "Intervalle",
					},
				],
			};
		},
		methods: {
			new_job: async function () {
				this.$router.push({ path: "/planification/nouveau" });
			},
			getProjects: async function () {
				try {
					var list_projects = await projects.getAll(true);
					for (var i = 0; i < list_projects.length; i++) {
						this.list_projects[list_projects[i].uid] =
							list_projects[i];
					}
				} catch (error) {
					console.log(error);
				}
			},
		},
		created: async function () {
			if (
				store.state.user.rules &&
				!store.state.user.rules.planification
			) {
				this.$router.push({ name: "profile" });
			}

			await this.getProjects();

			this.jobs = await agenda.getAll();
			this.jobs = this.jobs.jobs;

			this.jobs.sort(function (a, b) {
				return -a.nextRunAt.localeCompare(b.nextRunAt);
			});

			for (var i = 0; i < this.jobs.length; i++) {
				if (this.jobs[i].data.project_uid)
					this.jobs[i].project = this.list_projects[this.jobs[i].data.project_uid].libelle;
				else
					this.jobs[i].project = "fine tuning"
			}
		},
	};
</script>

<style></style>
